export const dias = [
  { nombre: "Lunes", numero: 1 },
  { nombre: "Martes", numero: 2 },
  { nombre: "Miércoles", numero: 3 },
  { nombre: "Jueves", numero: 4 },
  { nombre: "Viernes", numero: 5 },
  { nombre: "Sábado", numero: 6 },
];

export const horario = [
  {
    descripcion: "7:30 A 10hs",
    rango: "730|1000",
  },
  {
    descripcion: "10 A 12hs",
    rango: "1000|1200",
  },
  {
    descripcion: "12 A 14hs",
    rango: "1200|1400",
  },
  {
    descripcion: "14 A 16hs",
    rango: "1400|1600",
  },
  {
    descripcion: "16 A 18hs",
    rango: "1600|1800",
  },
  {
    descripcion: "18 A 20hs",
    rango: "1800|2000",
  },
];

export const rangoHorarioDefaultKinesio = [
  "730|1000",
  "1000|1200",
  "1200|1400",
  "1400|1600",
  "1600|1800",
  "1800|2000",
];

export const diasDefaultKinesio = ["1", "2", "3", "4", "5", "6"];

export const obtenerRangoHorario = (rangos) => {
  const resultados = [];

  rangos.forEach((rango) => {
    let horaMin = "";
    let horaMax = "";

    switch (rango) {
      case "Mañana":
        horaMin = "07";
        horaMax = "12";
        break;
      case "Media Tarde":
        horaMin = "12";
        horaMax = "16";
        break;
      case "Tarde":
        horaMin = "16";
        horaMax = "19";
        break;
      case "Noche":
        horaMin = "19";
        horaMax = "24";
        break;
      case "Madrugada":
        horaMin = "00";
        horaMax = "07";
        break;
      default:
        break;
    }

    resultados.push({ horaMin, horaMax });
  });

  return resultados;
};

export const createDtoTurnosDisponiblesKin = ({
  fechaDesde,
  idGrupoMedico,
  listDias,
  listHorario,
  sectorTurno,
  particular,
}) => {
  const dto = {
    cantidad: 10,
    fechaDesde: fechaDesde,
    idGrupoMedico: idGrupoMedico,
    listDias: listDias,
    listHorario: listHorario,
    particular: particular,
    sectorTurno: sectorTurno,
  };
  return dto;
};
